/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/


"use strict";

angular.module("exploitation")
	.controller("EitiCompaniesCtrl", ["$scope", "Utils", "companies", "$uibModal", "EitiCompaniesService", "toastr",
		function ($scope, Utils, companies, $uibModal, EitiCompaniesService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			companies: companies.data
		};

		var deleteModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/

		/**
             * Ouvrir la modal de suppression d'un client.
             */
		$scope.openDeleteModal = function (company) {
			$scope.data.entityToDelete = company;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};


		$scope.deleteEntity = function(company) {
			EitiCompaniesService.deleteCompany(company.id).then((response) => {
				const lineIds = response.data;
				function deleteLines(index) {
					if (index >= lineIds.length) {
						toastr.success("", "Compagnie supprimée");
						EitiCompaniesService.getAll(true).then((response) => {
							$scope.data.companies = response.data;
							deleteModal.close();
						});
						return;
					}
					if (lineIds) {
						EitiCompaniesService.deleteLine(lineIds[index])
							.then(() => {
								deleteLines(index + 1);
							})
							.catch((error) => {
								toastr.error(error.data.message, "Problème lors de la suppression de la ligne");
							});
					}

				}

					// Commence la suppression des lignes
					deleteLines(0);
				})
				.catch((error) => {
					toastr.error(error.data.message, "Problème lors de la suppression de la compagnie");
				});
		};
	}]);